// src/Login.tsx
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import AnimatedLogo from "./AnimatedLogo";
import "./Login.css";

const Login: React.FC = () => {
  const { loginWithRedirect, isLoading } = useAuth0();

  return (
    <div className="login-container">
      <div className="login-header">
        <div className="login-logo">
          <AnimatedLogo size={80} />
        </div>
        <h1 className="login-title">Clouseau AI Access Network Analyzer</h1>
        <p className="login-subtitle">
          AI-powered security analytics for building access systems
        </p>
      </div>

      <div className="login-form-container">
        <button
          className="login-button"
          onClick={() => loginWithRedirect()}
          disabled={isLoading}
        >
          {isLoading ? "Redirecting…" : "Log in"}
        </button>
      </div>
    </div>
  );
};

export default Login;
